import React, { useState } from 'react';
import { useEffect } from 'react';
import jobService from '../../utils/services/jobService';

import styles from './addJobTwo.module.scss';

const AddJobTwo = ({ jobPost, setJobPost, steps, setSteps, createdPostId }) => {
  const [isFilled, setIsFilled] = useState(false);

  useEffect(() => {
    if (
      jobPost.requirements.salary &&
      jobPost.requirements.jobType &&
      jobPost.requirements.jobCategory &&
      jobPost.requirements.experience &&
      jobPost.requirements.location &&
      jobPost.requirements.remote !== ''
    ) {
      setIsFilled(true);
    } else {
      setIsFilled(false);
    }
  }, [jobPost]);

  const requirementsOnChangeHandle = (e) => {
    const value = e.target.value;

    setJobPost({
      ...jobPost,
      requirements: { ...jobPost.requirements, [e.target.name]: value },
    });
  };

  const formTwohandle = (e) => {
    e.preventDefault();
    setSteps({ ...steps, stepThree: true });

    //call API to update job
    const formData = {
      job: {
        requirements: { ...jobPost.requirements },
      },
    };

    const result = jobService.updateJob(createdPostId, formData).then((res) => {
      if (res.data.success) {
        //tell the user something?
        console.log(res.data);
      }
    });
  };
  return (
    <section className={styles.jobRequirements}>
      <h2 className={styles.jobRequirements_heading}>
        Add job requirements and press continue
      </h2>
      <form className={styles.requirementsForm} action="">
        <div className={styles.formGroup}>
          <label htmlFor="salary">Salary</label>
          <input
            id="salary"
            type="text"
            name="salary"
            aria-label="Enter salary"
            placeholder="E.g 0-30 000 *"
            onChange={(e) => {
              requirementsOnChangeHandle(e);
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="jobType">Job type</label>
          <input
            id="jobType"
            type="text"
            name="jobType"
            aria-label="Enter job type"
            placeholder="E.g Full-time *"
            onChange={(e) => {
              requirementsOnChangeHandle(e);
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="jobCategory">Job category</label>
          <input
            id="jobCategory"
            type="text"
            name="jobCategory"
            aria-label="Enter job category"
            placeholder="E.g Frontend developer *"
            onChange={(e) => {
              requirementsOnChangeHandle(e);
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="experience">Experience</label>
          <input
            id="experience"
            type="text"
            name="experience"
            aria-label="Enter experience"
            placeholder="E.g 0-3 *"
            onChange={(e) => {
              requirementsOnChangeHandle(e);
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="location">Location</label>
          <input
            id="location"
            type="text"
            name="location"
            aria-label="Enter job location"
            placeholder="E.g Malmö *"
            onChange={(e) => {
              requirementsOnChangeHandle(e);
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="remote">
            Remote &#40;separate each preference with comma&#41;
          </label>
          <input
            id="remote"
            type="text"
            name="remote"
            aria-label="Enter remote preferences"
            placeholder="E.g In-house, hybrid *"
            onChange={(e) => {
              requirementsOnChangeHandle(e);
            }}
          />
        </div>
      </form>
      <button
        className={`${isFilled ? styles.btnActive : styles.btn}`}
        onClick={(e) => {
          formTwohandle(e);
        }}
      >
        Continue
      </button>
    </section>
  );
};

export default AddJobTwo;
